/* eslint-disable @stylistic/max-len */
import type {RefObject} from 'react';

/**
 * The `WineBarIconProps` interface defines the properties for the WineBarIcon component.
 */
interface WineBarIconProps {
    /** CSS class to override default styling. */
    className?: string;
    /** Primary color of the icon. */
    color1?: string;
    /** Height of the icon. */
    height?: number | string;
    ref?: RefObject<SVGSVGElement>;
    /** Test ID for Cypress. */
    testId?: string;
    /** Width of the icon. */
    width?: number | string;
}

/**
 * Material Symbol "wine_bar" — outlined, weight 300.
 * Wine glass icon for the Genuss (Enjoyment) category.
 *
 * @param props           The component props.
 * @param props.className CSS class override.
 * @param props.color1    Primary icon color.
 * @param props.height    Icon height.
 * @param props.ref       SVG element ref.
 * @param props.testId    Test identifier.
 * @param props.width     Icon width.
 * @returns A React SVG element.
 */
export const WineBarIcon = ({
    className = '',
    color1 = 'currentColor',
    height,
    ref,
    testId = 'WineBarIcon',
    width
}: WineBarIconProps) => (
    <svg
        ref={ref}
        className={className}
        data-cy={testId}
        fill={color1}
        height={height}
        viewBox="0 -960 960 960"
        width={width}
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d="M333.85-140v-45.39h123.46v-187.69q-95.54-13.61-147.58-77.19-52.04-63.58-52.04-149.73v-220h444.62v220q0 86.15-52.04 149.73-52.04 63.58-147.58 77.19v187.69h123.46V-140h-292.3Zm266.46-325.38q51.31-50 55.77-111.93H303.92q3.85 61.93 55.46 111.93 51.62 50 120.62 50t120.31-50ZM303.08-622.69h353.84v-151.92H303.08v151.92ZM480-415.38Z" />
    </svg>
);

WineBarIcon.displayName = 'WineBarIcon';